import { Alert as AntAlert } from 'antd';
import { Box } from 'theme-ui';

import type { Props } from './types';

export function Alert({
  description,
  message,
  showIcon,
  size,
  sx,
  type,
  ...rest
}: Props) {
  const isLarge = size === 'large';

  return (
    <Box
      sx={{
        '.ant-alert-with-description': {
          '.ant-alert-description': {
            color: 'gray-8',
          },
          '.ant-alert-message': {
            color: 'gray-9',
          },
        },
        ...(isLarge
          ? {
              maxWidth: '460px',
            }
          : {}),
        ...sx,
      }}
      {...rest}
    >
      <AntAlert
        description={description}
        message={message}
        showIcon={showIcon}
        type={type}
      />
    </Box>
  );
}
